module.exports = __webpack_public_path__ + "static/media/google-logo-icon-PNG-Transparent-Background.0dd54f85.png";